import { Row, Col, Modal, Skeleton, Badge, Image, Button } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../../hooks/useRequest";
import { ShowToast, Severty } from "../../../helper/toast";
import apiPath from "../../../constants/apiPath";
import moment from "moment";
import notfound from "../../../assets/images/not_found.png";

export const ViewAttribute = ({ show, hide, data }) => {

    const { request } = useRequest()
    const [loading, setLoading] = useState(false)
    const [list, setList] = useState([])

    const fetchData = () => {
        request({
            url: apiPath.viewProduct + "/" + data._id,
            method: 'GET',
            onSuccess: (data) => {
                setLoading(false);
                setList(data.data);
            },
            onError: (error) => {
                ShowToast(error, Severty.ERROR)
            }
        })
    }

    useEffect(() => {
        setLoading(true)
        fetchData(data._id);
    }, [])

  
    return (
        <Modal open={show} width={800} title='Product Variant Detail' footer={[<Button onClick={() => hide()}>Ok</Button>]} onCancel={hide}>
            {loading ? [1,2,3,4].map(item => <Skeleton active key={item} />) : 
                <Row gutter={6}>
                    <Col span={12} xs={24} md={24}>
                        <div className="view-main-list">

                            <div className="view-inner-cls">
                                <h5>Name:</h5>
                                <h6><span className="cap">{list.name ? list.name : '-'}</span></h6>
                            </div> 
                            <div className="view-inner-cls">
                                <h5>SKU:</h5>
                                <h6><span className="cap">{list.sku ? list.sku : '-'}</span></h6>
                            </div> 

                            <div className="view-inner-cls">
                                <h5>Price:</h5>
                                <h6><span className="cap">{list.price ? list.price : '-'}</span></h6>
                            </div>

                            <div className="view-inner-cls">
                                <h5>Part Number:</h5>
                                <h6><span className="cap">{list.part_number ? list.part_number : '-'}</span></h6>
                            </div>

                            {/* <div className="view-inner-cls">
                                <h5>Year Model:</h5>
                                <h6><span className="cap">{list.year_model && list.year_model ? list.year_model : '-'}</span></h6>
                            </div> */}

                            <div className="view-inner-cls">
                                <h5>Category:</h5>
                                <h6><span className="cap">{list.category_id && list.category_id.name ? list.category_id.name : '-'}</span></h6>
                            </div>

                            <div className="view-inner-cls">
                                <h5>Thumbnail:</h5>
                                <h6><Image width={60} src={list.thumbnail ? list.thumbnail : notfound} /></h6>
                            </div>

                            <div className="view-inner-cls">
                                <h5>Other Images:</h5>
                                <div className="" style={{display:'flex', alignItems:"center",gap:"8px", justifyContent:"end", width:"100%"}}>
                                    {list && list.image && list.image.length > 0 ? list.image.map((item, index) => 
                                    <h6 className=""><Image width={60} height={40} src={item} /></h6>
                                    ) : <h6><Image width={60} height={40} src={notfound} /></h6>}
                                </div>
                            </div>

                            <div className="view-inner-cls">
                                <h5>Description:</h5>
                                <h6>{list.description ? <p dangerouslySetInnerHTML={{__html: list.description}}></p>   : "-"}</h6>
                            </div>

                            <div className="view-inner-cls">
                                <h5>Featured:</h5>
                                <h6>{list.is_featured ? <Badge status="success" text="Yes" /> : <Badge status="error" text="No" />}</h6>
                            </div>

                            <div className="view-inner-cls">
                                <h5>Status:</h5>
                                <h6>{list.is_active ? <Badge status="success" text="Active" /> : <Badge status="error" text="InActive" />}</h6>
                            </div>

                        
                            <div className="view-inner-cls">
                                <h5>Attribute Combination:</h5>
                                <Row className="text-right">
                                <Col span={24}>
                                    {list && list.attribute && list.attribute.length > 0 && list.attribute.map((item, index) => 
                                    <h6 className="cap mt-1">{index+1}) {item.name} : {item.value} &nbsp;</h6>
                                    )}
                                </Col>
                                </Row>
                            </div>
                        

                            <div className="view-inner-cls">
                                <h5>Created On:</h5>
                                <h6>{list.created_at ? moment(list.created_at).format('DD-MMM-YYYY') : '-'}</h6>
                            </div>

                        </div>
                    </Col>
                </Row>
            }
        </Modal>
    )
}


